import { EVENT_TIMER_TICK, EVENT_TIMER_TICK_START, EVENT_TIMER_TICK_STOP } from "./Events";
import Hubx from "./HubX.js";

export default class Timer {
  hub: Hubx;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  interval: any;

  constructor(hub: Hubx) {
    this.hub = hub;
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.hub.attach(EVENT_TIMER_TICK_START, this.start);
    this.hub.attach(EVENT_TIMER_TICK_STOP, this.stop);
  }

  start(time: number, event = EVENT_TIMER_TICK) {
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.hub.notify(event, {
        now: new Date().getTime(),
        span: time,
      });
    }, time);
  }

  stop() {
    clearInterval(this.interval);
  }
}
